import { StyleSheet } from 'react-native';

import { Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes';

const style = StyleSheet.create({
  totalPayText: {
    marginTop: 20,
    marginVertical: 15,
    ...Fonts.type.bold,
    fontSize: 16,
    paddingHorizontal: 16,
  },
  sectionTitleNewPlan: {
    marginTop: 40,
  },
  totalPayContent: {
    paddingBottom: 10,
    paddingHorizontal: 16,
  },
  separator: theme => ({
    height: 1,
    backgroundColor: theme.colors.borderColorThree,
    marginBottom: 8,
  }),
  totalPayContentRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginVertical: 5,
  },
  contentText: {
    ...Fonts.type.bold,
    fontSize: 16,
  },
  sectionTitle: {
    fontSize: 25,
    marginVertical: 20,
    fontFamily: Fonts.type.VodafoneLt,
    paddingHorizontal: 16,
  },
  deviceTotalCost: {
    ...Fonts.type.bold,
  },
});
export default style;
